export default __webpack_public_path__ + "static/media/3X4A0544.9fd9da14.jpg";